<template>
  <div class="footer-nav">
    <div
      v-for="(line, indexLine) in chunkColumns(footerNav, 2)"
      :key="indexLine"
      class="footer-nav__line"
    >
      <div
        v-for="(column, indexColumn) in line"
        :key="indexColumn"
        class="footer-nav__column"
      >
        <UiText
          class="footer-nav__title"
          font="body-heading-4"
          color="typography-title01"
          :text="column.title"
        />
        <ul class="footer-nav__list">
          <li
            v-for="(item, indexItem) in column.list"
            :key="indexItem"
            class="footer-nav__item"
          >
            <UiLink
              :href="item.path"
              class="footer-nav__link"
              size="small"
              color="gray"
              :data-id="`footer-nav-left-pages-${indexColumn}${indexItem}-link`"
              :text="item.title"
              v-on="item.events"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FooterNav',
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    footerNav() {
      return [
        {
          title: this.$t('footer.nav.about'),
          list: [
            this.$pathObj.responsibleGaming,
            this.$pathObj.amlpolicy,
            this.$pathObj.intellectualProperty,
            // this.$pathObj.partners,
          ],
        },
        {
          title: this.$t('footer.nav.conditions'),
          list: [
            this.$pathObj.gameRules,
            this.$pathObj.rules,
            {
              title: this.$i18n.locale === 'ua' ? 'Договір публічної оферти' : 'Договор публичной оферты',
              tag: 'a',
              path: `${this.$config.baseURL}/docs/PUBLIC_AGREEMENT.pdf`,
            },
            this.$pathObj.policy,
          ],
        },
        {
          title: this.$t('footer.nav.promotions'),
          list: [
            {
              ...this.$pathObj.bonuses,
              ...(this.isLoggedIn ? null : { path: this.$paths.welcomePack }),
            },
            this.$pathObj.bonusList,
          ],
        },
        {
          title: this.$t('footer.nav.questions'),
          list: [
            {
              title: this.$t('footer.nav.support'),
              path: '',
              events: {
                click: this.open_globalModalSupport,
              },
            },
            this.$pathObj.faq,
          ],
        },
      ]
    },
  },
  methods: {
    ...mapActions('globalModal', ['open_globalModalSupport']),
    chunkColumns(arr, size) {
      const result = []
      for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size))
      }
      return result
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
